import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { kebabCase } from 'lodash';
import { Button as MuiButton, styled, } from '@mui/material';
import { Tooltip } from '../Tooltip';
import { LoadingIndicator } from '../LoadingIndicator';
import useMediaQueries from '../../../hooks/useMediaQueries';
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
const Button = ({ label, color = 'primary', size = 'medium', disabled = false, leftIcon = undefined, rightIcon = undefined, onClick = undefined, onComplete = undefined, variant = 'outlined', fullWidth = false, helpText = undefined, tooltipPlacement = 'bottom', isWaiting = false, isFileUpload = false, onFileChange, fileFormats, margin, parent = '', fillParentOnMobileView = false, ...muiProps }) => {
    const { fitForDesktop } = useMediaQueries();
    const shouldFillParent = fillParentOnMobileView && !fitForDesktop;
    // data-testid preparation
    const testIdArray = ['Button'];
    parent && testIdArray.push(parent);
    label && testIdArray.push(kebabCase(label));
    const handleComplete = async () => {
        if (onComplete) {
            await onComplete();
        }
    };
    const handleClick = async (e) => {
        if (onClick) {
            await onClick(e);
        }
        await handleComplete();
    };
    const handleInputChange = (e) => {
        onFileChange?.(e);
        // This clears the value so that the same file CAN be selected twice in a row. 
        e.target.value = '';
    };
    const buttonElement = (_jsx(MuiButton, { fullWidth: fullWidth, color: color, variant: variant, size: size, onClick: handleClick, disabled: disabled || isWaiting, startIcon: isWaiting ? (_jsx(LoadingIndicator, { size: "20px", color: "inherit" })) : leftIcon, endIcon: rightIcon, component: isFileUpload ? 'label' : undefined, "data-testid": testIdArray.join(':'), ...muiProps, sx: {
            ...muiProps.sx,
            margin,
            width: shouldFillParent ? '100%' : undefined,
        }, children: _jsxs("span", { children: [label, isFileUpload && _jsx(VisuallyHiddenInput, { type: "file", onChange: handleInputChange, accept: fileFormats })] }) }));
    if (helpText) {
        return (_jsx(Tooltip, { text: helpText, placement: tooltipPlacement, children: buttonElement }));
    }
    return buttonElement;
};
export default Button;
//# sourceMappingURL=index.js.map